export const TAB_VISITOR = 'visitor';
export const TAB_NOTES = 'notes'; // This data is loaded in ScrollingListContainer dynamically
export const TAB_ERROR = 'error';
export const TAB_RELEASE = 'release';
export const TAB_WORK_ORDER = 'workOrder';
export const FILTER_VISITOR_VESSEL = 'Vessel';
export const FILTER_VISITOR_TURBINE = 'Turbine';

export const FILTER_ID_ALL = 'All';

export const defaultDataById = {
    error: {},
    release: {},
    workOrder: {},
    visitor: {},
};

export const defaultTabs = [
    {
        id: TAB_ERROR,
        name: 'Alarms',
        // active init
        isActive: true,
        activeFilterId: FILTER_ID_ALL,
        turbineAttr: 'turbine_key',
        sortFn: (a, b) => b.ts.value.localeCompare(a.ts.value),
        filters: [
            { id: FILTER_ID_ALL, mapping: null },
            { id: 'Inconsistency', mapping: 'generated_by', value: 'PLANETOS', disabled: true },
            { id: 'WPS', mapping: 'generated_by', value: 'WPS', disabled: true },
        ],
    },
    {
        id: TAB_RELEASE,
        name: 'Logs',
        activeFilterId: FILTER_ID_ALL,
        turbineAttr: 'turbine_key',
        sortFn: (a, b) => a.timestamp_index - b.timestamp_index,
        filters: [
            { id: FILTER_ID_ALL, mapping: null },
            { id: 'Turbine', mapping: 'entityType', value: 'ROP', disabled: true },
            { id: 'High Voltage', mapping: 'entityType', value: 'VISITOR_LOG', disabled: true },
        ],
    },
    {
        id: TAB_WORK_ORDER,
        name: 'Work Orders',
        activeFilterId: 'Issued',
        turbineAttr: 'turbine_key',
        sortFn: (a, b) => b.start_date.value.localeCompare(a.start_date.value),
        filters: [
            { id: 'Issued', mapping: 'status', value: 'ISSUED', disabled: false },
            { id: 'Scheduled', mapping: 'status', value: 'SCHEDULED', disabled: false },
            { id: 'Complete', mapping: 'status', value: 'COMPLETED', disabled: false },
            { id: 'Unplanned', mapping: 'status', value: 'UNPLANNED', disabled: false },
        ],
        // sort: ['WOC', 'Date']
    },
    {
        id: TAB_VISITOR,
        name: 'People',
        turbineAttr: 'turbine_denormalised',
        activeFilterId: 'Log',
        sortFn: (a, b) => {
            // b.time_entered.value
            //     ? b.time_entered.value.localeCompare(a.time_entered.value)
            //     : b.time_entered.values[0].localeCompare(a.time_entered?.values?.[0] || '');

            // Extract values to compare
            const valueA = b.time_entered.value || b.time_entered.values?.[0] || '';
            const valueB = a.time_entered.value || a.time_entered.values?.[0] || '';

            // Use Date for comparison if dealing with dates, or fallback to localeCompare for strings
            return new Date(valueA) - new Date(valueB);
        },
        filters: [
            {
                id: FILTER_VISITOR_TURBINE,
                mapping: 'location_type',
                value: 'TURBINE',
                disabled: false,
            },
            {
                id: FILTER_VISITOR_VESSEL,
                mapping: 'location_type',
                value: 'VESSEL',
                disabled: false,
            },
            { id: 'Log', mapping: null, disabled: false },
        ],
    },
    {
        id: TAB_NOTES,
        name: 'Notes & Exceptions',
        turbineAttr: 'turbine_key',
        activeFilterId: FILTER_ID_ALL,
        sortFn: (a, b) => b.start_date.localeCompare(a.start_date),
        hidden: true,
        filters: [
            { id: FILTER_ID_ALL, mapping: null },
            { id: 'Notes', mapping: 'type', value: 'note', disabled: false },
            { id: 'Exceptions', mapping: 'type', value: 'exception', disabled: false },
        ],
    },
];
